















































import GlobalMixin from "@/shared/mixins/globalMixin";
import "dayjs/locale/pt-br";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import EventosCardSuporte from "./components/suporte/EventosCardSuporte.vue";
import ErrosCardSuporte from "./components/suporte/ErrosCardSuporte.vue";
import ProcessosFalhaCardSuporte from "./components/suporte/ProcessosFalhaCardSuporte.vue"
import EventosTabelaSuporte from "./components/suporte/EventosTabelaSuporte.vue"
import ErrosTabelaSuporte from "./components/suporte/ErrosTabelaSuporte.vue"

@Component({
  components: {
    EventosCardSuporte,
    ErrosCardSuporte,
    ProcessosFalhaCardSuporte,
    EventosTabelaSuporte,
    ErrosTabelaSuporte,
  }
})
export default class DashboardTvSuporte extends Mixins(GlobalMixin) {
  show = false;

  @Prop() date!: string | null;

  mounted() {
    this.fetch();
  }

  @Watch("date")
  fetch() {
    this.show = true;
  }
}
